import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/Auth.context';
import { Spinner, Center } from '@chakra-ui/react';

const AdminRoute = ({ children }) => {
  const { user, ready } = useAuth();

  if (!ready) {
    return (
      <Center mt={20}>
        <Spinner size="lg" />
      </Center>
    );
  }

  if (!user || !user.roles.includes('admin')) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
